import { Link } from 'react-router-dom';
import { Home, Search, AlertTriangle } from 'lucide-react';

const NotFoundPage = () => {
    return (
        <div className="container mx-auto px-4 py-16">
            <div className="max-w-2xl mx-auto text-center">
                <div className="mb-8">
                    <AlertTriangle className="h-24 w-24 text-yellow-500 mx-auto mb-6" />
                    <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
                    <h2 className="text-2xl font-semibold text-gray-700 mb-4">Page Not Found</h2>
                    <p className="text-lg text-gray-600 mb-8">
                        Sorry, we couldn't find the page you're looking for. The page may have been
                        moved, deleted, or you may have entered an incorrect URL.
                    </p>
                </div>

                <div className="space-y-4 sm:space-y-0 sm:space-x-4 sm:flex sm:justify-center">
                    <Link
                        to="/"
                        className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-lg text-white bg-primary-600 hover:bg-primary-700 transition-colors duration-200"
                    >
                        <Home className="h-5 w-5 mr-2" />
                        Go Home
                    </Link>

                    <Link
                        to="/search"
                        className="inline-flex items-center justify-center px-6 py-3 border border-gray-300 text-base font-medium rounded-lg text-gray-700 bg-white hover:bg-gray-50 transition-colors duration-200"
                    >
                        <Search className="h-5 w-5 mr-2" />
                        Search LEIs
                    </Link>
                </div>

                <div className="mt-12 pt-8 border-t border-gray-200">
                    <h3 className="text-lg font-semibold text-gray-900 mb-4">Popular Pages</h3>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
                        <Link
                            to="/the-lei-system"
                            className="text-primary-600 hover:text-primary-800 hover:underline"
                        >
                            About the LEI System
                        </Link>
                        <Link
                            to="/about-openleis"
                            className="text-primary-600 hover:text-primary-800 hover:underline"
                        >
                            About OpenLEIs
                        </Link>
                        <Link
                            to="/search"
                            className="text-primary-600 hover:text-primary-800 hover:underline"
                        >
                            Search LEIs
                        </Link>
                        <Link
                            to="/privacy-policy"
                            className="text-primary-600 hover:text-primary-800 hover:underline"
                        >
                            Privacy Policy
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotFoundPage;
